<template>
  <div
    v-if="featureFlagMessage !== null"
    class="text-white py-3 px-4 shadow-lg bg-orange-primary"
  >
    <div class="container flex">
      <div class="flex space-x-3">
        <div>
          <p class="text-sm md:text-base">
            🔧 {{ featureFlagMessage }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { maintenanceMessage } = useFeatureFlag()
const featureFlagMessage = ref(null)

onMounted(() => {
  featureFlagMessage.value = maintenanceMessage()
})
</script>
